import React from 'react';
import './LoadingScreen.css';

interface LoadingScreenProps {
  message?: string;
  submessage?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = "Hang tight!",
  submessage = "Getting everything ready for you",
}) => {
  return (
    <div className="loading-screen">
      <div className="loading-screen__logo-container">
        <img
          src="/whale-happy.png"
          alt="Loading"
          className="loading-screen__logo"
        />
      </div>
      <h2 className="loading-screen__message">{message}</h2>
      <p className="loading-screen__submessage">
        {submessage}
        <span className="loading-screen__dots">
          <span className="loading-screen__dot" />
          <span className="loading-screen__dot" />
          <span className="loading-screen__dot" />
        </span>
      </p>
    </div>
  );
};

export default LoadingScreen;
